import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "GroupLayout"
};
const _hoisted_2 = {
  key: 0,
  class: "logoLink",
  href: "#"
};
const _hoisted_3 = {
  style: {
    "font-size": "20px",
    "line-height": "30px",
    "font-weight": "800"
  }
};
const _hoisted_4 = ["data-id", "onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  style: {
    "font-size": "20px",
    "line-height": "30px",
    "font-weight": "800"
  }
};
const _hoisted_7 = {
  class: "logoLink"
};
const _hoisted_8 = ["data-id", "onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 1,
  class: "logoLink"
};
const _hoisted_11 = {
  style: {
    "font-size": "20px",
    "line-height": "30px",
    "font-weight": "800"
  }
};
const _hoisted_12 = ["data-id", "onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  style: {
    "font-size": "20px",
    "line-height": "30px",
    "font-weight": "800"
  }
};
const _hoisted_15 = {
  class: "GHOperator"
};
const _hoisted_16 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_GHSeparator = _resolveComponent("GHSeparator");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
    class: "SubGroupLayout",
    style: _normalizeStyle({
      'height': `${$props.rows * 40}px`,
      'grid-template-rows': `repeat(${$props.rows},40px)`
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredGroup, (comp, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [comp.is_enable && comp.rhino_versions.indexOf(_ctx.current_rhino_version) !== -1 ? (_openBlock(), _createElementBlock("a", _hoisted_2, [_ctx.current_tag === 'All' || comp.tags.includes(_ctx.current_tag) || _ctx.current_tag === 'Recent Updates' && comp.is_recent_updated ? (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 0,
      placement: "bottom-start",
      effect: "customized",
      "hide-after": 0
    }, {
      content: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createElementVNode("b", null, _toDisplayString(comp.name), 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _createTextVNode(_toDisplayString(comp.sub_name), 1)])]),
      default: _withCtx(() => [_createElementVNode("div", {
        "data-id": comp.id,
        class: _normalizeClass(['GHOperator', {
          shake: $data.flashingIconId === comp.id,
          highlighted: $props.highlightedIconId === comp.id,
          'focus-pulse': _ctx.focusIconId === comp.id
        }]),
        onClick: _withModifiers($event => $options.onClickComp(comp.name_in_url, comp.id), ["stop"])
      }, [_createElementVNode("img", {
        class: "ghiconenable",
        src: comp.icon
      }, null, 8, _hoisted_5)], 10, _hoisted_4)]),
      _: 2
    }, 1024)) : (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 1,
      placement: "bottom-start",
      effect: "customized",
      "hide-after": 0
    }, {
      content: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createElementVNode("b", null, _toDisplayString(comp.name), 1), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)), _createTextVNode(_toDisplayString(comp.sub_name), 1)])]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        "data-id": comp.id,
        class: _normalizeClass(['GHOperator', {
          shake: $data.flashingIconId === comp.id,
          highlighted: $props.highlightedIconId === comp.id,
          'focus-pulse': _ctx.focusIconId === comp.id
        }]),
        onClick: _withModifiers($event => $options.onClickComp(comp.name_in_url, comp.id), ["stop"])
      }, [_createElementVNode("img", {
        class: "NoNeedToPayAttention",
        src: comp.icon
      }, null, 8, _hoisted_9)], 10, _hoisted_8)])]),
      _: 2
    }, 1024))])) : _createCommentVNode("", true), !comp.is_enable ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_ctx.current_tag === 'All' || comp.tags.includes(_ctx.current_tag) || _ctx.current_tag === 'Recent Updates' && comp.is_recent_updated ? (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 0,
      placement: "bottom-start",
      effect: "customized",
      "hide-after": 0
    }, {
      content: _withCtx(() => [_createElementVNode("span", _hoisted_11, [_createElementVNode("b", null, _toDisplayString(comp.name), 1)]), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("span", {
        style: {
          "color": "#464646",
          "font-size": "16px",
          "font-weight": "400",
          "font-style": "italic"
        }
      }, "To be updated", -1))]),
      default: _withCtx(() => [_createElementVNode("div", {
        "data-id": comp.id,
        class: _normalizeClass(['GHOperator', {
          shake: $data.flashingIconId === comp.id,
          highlighted: $props.highlightedIconId === comp.id,
          'focus-pulse': _ctx.focusIconId === comp.id
        }]),
        onClick: _withModifiers($event => $options.onClickComp(comp.name_in_url, comp.id), ["stop"])
      }, [_createElementVNode("img", {
        class: "ghicondisable",
        src: comp.icon
      }, null, 8, _hoisted_13)], 10, _hoisted_12)]),
      _: 2
    }, 1024)) : (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 1,
      placement: "bottom-start",
      effect: "customized",
      "hide-after": 0
    }, {
      content: _withCtx(() => [_createElementVNode("span", _hoisted_14, [_createElementVNode("b", null, _toDisplayString(comp.name), 1)]), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("span", {
        style: {
          "color": "#464646",
          "font-size": "16px",
          "font-weight": "400",
          "font-style": "italic"
        }
      }, "To be updated", -1))]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
        class: "ghicondisableblur",
        src: comp.icon
      }, null, 8, _hoisted_16)])]),
      _: 2
    }, 1024))])) : _createCommentVNode("", true)]);
  }), 128))], 4), [[_vShow, $options.hasVisibleIcons]]), _withDirectives(_createVNode(_component_GHSeparator, {
    id: "Sep"
  }, null, 512), [[_vShow, $options.hasVisibleIcons]])]);
}